import React from 'react';
import classnames from 'classnames/bind';
import styles from './index.module.scss';
const cx = classnames.bind(styles);

interface TalkingBoxProps {
  fadeIn: boolean;
}

const Tip = ({ fadeIn }: TalkingBoxProps) => {
  return (
    <div className={cx('commonBox', 'whiteTag')}>
      {/* 책갈피 */}
      <div className={cx('tagBox')}>
        <span className={cx('num')}>04.</span>
        프로필 작성 TIP
      </div>
      {/* 대화 내용 */}
      <div className={cx('sayingInner')}>
        <div className={cx('talkingBox', { on: fadeIn })}>
          <span className={cx('saying')}>
            학점, 자격증, 개인 공부, 조별 과제, 대외활동, 커리어 관리 모두 괜찮은데
            <br />
            <strong>기업에게 어떻게 보여주지?</strong>
          </span>
        </div>
        <div className={cx('talkingBox', { on: fadeIn })}>
          <span className={cx('saying')}>
            나는 내 프로필만 올리면
            <br />
            <strong>기업에 알아서 보여줄 수 있는 방법이 없을까?</strong>
          </span>
        </div>
        <div className={cx('talkingBox', { on: fadeIn })}>
          <span className={cx('saying')}>
            JOBDA에서 프로필 입력하면
            <br />
            <strong>그냥 이력서 올리는 거랑 뭐가 다른거야?</strong>
          </span>
        </div>
        <div className={cx('talkingBox', { on: fadeIn })}>
          <span className={cx('saying', 'importBox')}>
            JOBDA 프로필 작성만 하면 인사담당자들에게
            <br />
            알아서 내 프로필이 노출된다구!
          </span>
        </div>
      </div>
    </div>
  );
};

export default Tip;
